module.exports = __webpack_public_path__ + "img/dirty_bubble.9f688319.jpg";